<template>
  <v-app :style="showMainView ? 'max-width: 940px; margin: auto;' : ''">
    <v-content>
      <main-view v-if="showMainView" @open-test-view="showMainView = false"/>
      <calculation-test-view v-else></calculation-test-view>
    </v-content>
  </v-app>
</template>

<script>
import MainView from './views/MainView';
import CalculationTestView from "./views/CalculationTestView";

export default {
  name: 'App',

  components: {
    MainView,
    CalculationTestView
  },

  data: () => ({
    showMainView: true,
  }),
};
</script>

<style lang="scss">
  * {
    font-family: 'Avenir Next', sans-serif;
  }

  .v-application--wrap {
    min-height: auto !important;
    padding-top: 10px;
    padding-bottom: 25px;
  }

  input, input:focus {
    border: 0;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    cursor: default;
    transition: none;
    display: inline;
    height: inherit;
    background-color: inherit;
    margin-bottom: 0;
  }

  .v-label {
    color: rgba(0,0,0,0.8) !important;
  }

  .v-messages {
    color: rgba(0,0,0,0.85) !important;
  }

  .row {
    margin-left: -12px !important;
    margin-right: -12px !important;
    padding: 0 !important;

    &.no-gutters {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  .container {
    margin-right: 0;
    margin-left: 0;
    box-sizing: border-box;
  }

  .container:before, .container:after {
    display: none;
    clear: none;
  }

  .row:before, .row:after {
    display: none;
    clear: none;
  }

  .v-input__slot {
    width: auto;
  }

  @media only screen and (max-width: 600px) {
    h3 {
      font-size: 14px !important;
      line-height: 16px !important;
    }

    .row {
      margin-left: -10px !important;
      margin-right: -10px !important;
    }
  }
</style>
